module.exports = __webpack_public_path__ + "img/elementheights_jaka.d991ffbc.png";